import React from "react";
import { Route, Redirect } from "react-router-dom";
import { messageService } from "./subscriberService";
import { useSelector } from "react-redux";

const protectedRoute = ({ component: Component, ...rest }) => {
  messageService.count = [];
  EventListners(false);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (localStorage.getItem("accessToken")) {
          return <Component {...props} />;
        } else {
          return RedirectLocation("/SignIn", props.location);
        }
      }}
    />
  );
};

export const ProtectedProfile = ({ component: Component, ...rest }) => {
  messageService.count = [];
  const { currentStatus } = useSelector((state) => state.profile.profileData);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (currentStatus === "complete") {
          return <Component {...props} />;
        } else {
          return RedirectLocation("/SignUpSteps", props.location);
        }
      }}
    />
  );
};

export const CompleteProfile = ({ component: Component, ...rest }) => {
  messageService.count = [];
  const { currentStatus } = useSelector((state) => state.profile.profileData);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (currentStatus !== "complete") {
          return <Component {...props} />;
        } else {
          return RedirectLocation("/", props.location);
        }
      }}
    />
  );
};

const ProtectedOndemand = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (
          localStorage.getItem("workoutData") &&
          localStorage.getItem("ondemandData")
        ) {
          return <Component {...props} />;
        } else {
          return RedirectLocation("/", props.location);
        }
      }}
    />
  );
};

const LoginRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (localStorage.getItem("accessToken")) {
          return RedirectLocation("/", props.location);
        } else {
          return <Component {...props} />;
        }
      }}
    />
  );
};

export default protectedRoute;
export { LoginRoute, ProtectedOndemand };

const RedirectLocation = (path, location) => {
  return (
    <Redirect
      to={{
        pathname: path,
        state: { from: location },
      }}
    />
  );
};

const EventListners = (status) => {
  window.addEventListener("storage", (data) => {
    console.log(data);
    if (data.key === null) {
      window.location.reload();
    } else if (
      data.key === "accessToken" &&
      (status ? data.newValue !== null : data.newValue === null)
    ) {
      window.location.reload();
    }
  });
};
